<template>
<div id="temp_index">
    <dv-full-screen-container class="bg">
        <dv-loading v-if="loading">Loading...</dv-loading>
        <div v-else class="host-body">
            <!-- 第一行标题装饰条 -->
            <div class="d-flex jc-center">
                <dv-decoration-10 :color="['#800618', '#800618']" style="width:20%;height:.0625rem;" />
                <div class="d-flex jc-center" style="width:60%;">
                    <dv-decoration-8 :color="['#800618', '#000f37']" style="width:20%;height:.625rem;" />
                    <div class="title" style="width:60%;">
                        <span class="title-text">{{title}}</span>
                        <dv-decoration-5 class="title-bototm" :color="['#800618', '#800618']" style="width:3.8rem;padding-top:0.18rem;" />
                    </div>
                    <dv-decoration-8 :reverse="true" :color="['#800618', '#000f37']" style="width:20%;height:.625rem;" />
                </div>
                <dv-decoration-10 :color="['#800618', '#800618']" style="width:20%;height:.0625rem;transform: rotateY(180deg);" />
            </div>

            <!-- 第二行 -->
            <div class="d-flex jc-between px-2">
                <div class="d-flex" style="width: 40%">
                    <div class="react-right ml-4" style="width: 5rem; background-color: #152957;">
                        <span class="react-before"></span>
                        <div style="float: left;transform: skewX(-45deg);font-weight: 600;font-size: 0.28rem;"></div>
                    </div>
                    <div class="react-right ml-3" style="width: 5rem;background-color: #152957;">
                    </div>
                </div>
                <div style="width: 40%" class="d-flex">
                    <div class="react-left mr-3" style="width: 5rem; background-color: #152957;">
                    </div>
                    <div class="react-left mr-4" style="width: 5rem; background-color: #152957; text-align: right;">
                        <span class="react-after"></span>
                        <span class="text" style="font-size: 0.26rem;">{{date}}</span>
                    </div>
                </div>
            </div>
            <div class="body-box">
                <!-- 第三行数据 -->
                <div class="content-box">
                    <div class="right-top">
                        <div style="height: 55vh;">
                            <dv-border-box-4 :reverse="true" :color="['#82001a', '#000170']" style="transform: rotateY(180deg);">
                                <top1 />
                            </dv-border-box-4>
                        </div>
                        <div style="padding: 0 0 0.25rem 0;height: 55vh;">
                            <dv-border-box-10 :color="['#82001a', '#82001a']">
                                <top2 />
                            </dv-border-box-10>
                        </div>
                        <div style="height: 55vh;">
                            <dv-border-box-4 :reverse="true" :color="['#69061a', '#000170']">
                                <top3 />
                            </dv-border-box-4>
                        </div>
                    </div>
                    <div class="right-bottom">
                        <div style="height: 32vh;">
                            <dv-border-box-9 :color="['#69061a','#000170']">
                                <bottom />
                            </dv-border-box-9>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </dv-full-screen-container>
</div>
</template>

<script>
var storage = window.localStorage;
var title = storage.getItem("title");
var schoolName = storage.getItem("schoolName");
if(title == 'false'){
    title = schoolName + '智慧测温大数据看板';
}
import top1 from "./top1";
import top2 from "./top2";
import top3 from "./top3";
import bottom from "./bottom";
export default {
    data() {
        return {
            loading: true,
            title: title,
            date: this.dateFormatToString(new Date()),
        };
    },
    components: {
        top1,
        top2,
        top3,
        bottom
    },
    mounted() {
        this.cancelLoading();
        this.initData();
        // 定时刷新时间
        let _this = this;
        // 定时器
        setInterval(() => {
            _this.date = _this.dateFormatToString(new Date()); // 修改数据date
        }, 1000);
    },
    methods: {
        //关闭loading加载条
        cancelLoading() {
            setTimeout(() => {
                this.loading = false;
            }, 1000);
        },
        initData() {
            this.$http.get("/dataView/getTempIndexInfo").then(res => {
                console.log(res);
            });
        },
        //日期格式化
        dateFormatToString(data) {
            let formatDateTime
            let Y = data.getFullYear()
            let M = data.getMonth() + 1
            let D = data.getDate()
            let H = data.getHours()
            let Min = data.getMinutes()
            let S = data.getSeconds()
            let W = data.getDay()
            H = H < 10 ? ('0' + H) : H
            Min = Min < 10 ? ('0' + Min) : Min
            S = S < 10 ? ('0' + S) : S
            switch (W) {
                case 0:
                    W = '天'
                    break
                case 1:
                    W = '一'
                    break
                case 2:
                    W = '二'
                    break
                case 3:
                    W = '三'
                    break
                case 4:
                    W = '四'
                    break
                case 5:
                    W = '五'
                    break
                case 6:
                    W = '六'
                    break
                default:
                    break
            }
            formatDateTime = Y + '年' + M + '月' + D + '日 ' + H + ':' + Min + ':' + S + ' 星期' + W;
            this.date = formatDateTime;
            return formatDateTime
        }
    },
    // 注意在vue实例销毁前，清除我们的定时器。
    destroyed() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/scss/tempIndex.scss";

#temp_index{
    .title {
        line-height: 0.8rem;
    
        .title-text {
            font-size: 0.45rem !important;
            width: 100%;
            font-weight: 600;
            background-image: linear-gradient(135deg, #00e2ff, #da00ff);
            -webkit-background-clip: text;
            color: transparent;
        }
    }
}
</style>
